import { render, staticRenderFns } from "./KeySpecItem.vue?vue&type=template&id=3dc72b5b&scoped=true"
import script from "./KeySpecItem.vue?vue&type=script&lang=js"
export * from "./KeySpecItem.vue?vue&type=script&lang=js"
import style0 from "./KeySpecItem.vue?vue&type=style&index=0&id=3dc72b5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc72b5b",
  null
  
)

export default component.exports